import { HStack, Section, VStack } from 'tio-ui/components/layout';
import { service } from '@ember/service';
import { t } from 'ember-intl';
import { array, hash } from '@ember/helper';
import ApplicationHistory from 'tio-common/components/tas/application-history';
import Component from '@glimmer/component';
import NavTabs from 'tio-reimagined/components/nav-tabs';
import type { Step } from 'tio-common/components/tio/progress-tracker-items';
import type ProgressBuilder from 'tio-common/services/progress-builder';
import type TASProgramInstanceModel from 'tio-data/models/tas-program-instance';
import VerticalProgressTracker from 'tio-common/components/tio/vertical-progress-tracker';

interface RouteSignature {
  Args: {
    model: TASProgramInstanceModel;
  };
}

export default class AuthenticatedTasProgramsHistory extends Component<RouteSignature> {
  @service declare progressBuilder: ProgressBuilder;

  get programProgress() {
    return this.progressBuilder.programProgress(this.args.model) as Step[];
  }

  <template>
    <VStack>
      <NavTabs
        @tabs={{array
          (hash label=(t "tas.program.program") route="authenticated.tas.programs.show")
          (hash label=(t "tas.program.details") route="authenticated.tas.programs.details")
          (hash label=(t "tas.program.history") route="authenticated.tas.programs.history")
        }}
      />
      <HStack>
        <ApplicationHistory
          @history={{@model.fullHistory}}
          @type="program"
          @title={{t "tuition_assistance.program_instances.history.header"}}
        />
        <Section class="md:w-1/3!">
          <:header>{{t "common.progress_tracker.program_progress"}}</:header>
          <:body>
            {{! TODO: using lists to show numbers causes flow issues. The ml-4 class will force
                the numbers into the box, but this isn't ideal as mobile view will have issues.
                Looks like the component is just a stack anyway so might be target for update. }}
            <VerticalProgressTracker class="ml-4" @steps={{this.programProgress}} />
          </:body>
        </Section>
      </HStack>
    </VStack>
  </template>
}
